import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { trackError } from '@mc/monitoring'
import { useStaticData } from '@mc/static-data-react'
import { type PrunedCourse } from 'libs/server/api'
import { PEN_6698_V1_CM_INSTRUCTOR_ACCOLADE_MODAL_FLAG_NAME } from './constants'

export const useCMInstructorAccoladeExperiment = () => {
  const { course } = useStaticData<{ course: PrunedCourse }>()
  const bucket = useBucket(PEN_6698_V1_CM_INSTRUCTOR_ACCOLADE_MODAL_FLAG_NAME)

  const hasAccolades = Boolean(course.instructorAccolades?.length)
  const shouldShowCMInstructorAccoladeExp = hasAccolades

  useEffect(() => {
    if (!hasAccolades && bucket === 'variant_1') {
      trackError(new Error('PEN-6698: Instructor accolades is missing'), {
        courseSlug: course.slug || '',
      })
    }
  }, [hasAccolades, course.slug, bucket])

  return { shouldShowCMInstructorAccoladeExp }
}
